module.exports = __webpack_public_path__ + "static/media/football.9f85fca0.jpg";